import React, { useState, useCallback, useEffect } from 'react'
import useThunkDispatch from 'hooks/useThunkDispatch'

import SocketAPI, { WSEventType } from 'utils/socketApi'
import { asyncGetCurrent, Reward } from 'store/services/User'
import AchievementIcon from './AchievementIcon'
import { Typography, InjectedSoundProps, withSoundEffectsContext } from '@astrid/components'

import './AchievementHandler.scss'

const AchievementHandler: React.FC<InjectedSoundProps> = ({ playSound }) => {
  const [showPopup, setShowPopup] = useState(false)
  const [achievementsQueue, setAchievementsQueue] = useState<Reward[]>([])
  const latestReward = achievementsQueue[0]
  const dispatch = useThunkDispatch()

  const removeFirstElementFromQueue = useCallback(() => {
    setShowPopup(false)
    setTimeout(() => {
      setAchievementsQueue((queue) => {
        if (queue.length >= 2) {
          playSound('achievement', () => setTimeout(removeFirstElementFromQueue, 1500))
          dispatch(asyncGetCurrent())
          setShowPopup(true)
        }
        return queue.slice(1)
      })
    }, 300)
  }, [playSound, dispatch])

  useEffect(() => {
    SocketAPI.on(WSEventType.NEW_REWARD, (reward: Reward) => {
      setAchievementsQueue((queue) => {
        if (queue.length === 0) {
          playSound('achievement', () => setTimeout(removeFirstElementFromQueue, 1500))
          dispatch(asyncGetCurrent())
          setShowPopup(true)
        }
        return [...queue, reward]
      })
    })
    // eslint-disable-next-line
  }, [])

  return (
    <div
      className={`achievement-popup${showPopup ? '--open' : ''}`}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <AchievementIcon reward={latestReward} />
      <div>
        <Typography component="p" variant="h4">
          Achievement Unlocked!
        </Typography>
        <Typography component="p" variant="exerciseS">
          {latestReward?.name}
        </Typography>
      </div>
    </div>
  )
}

export default withSoundEffectsContext(AchievementHandler)
